import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3519">
      <Navbar data-id="element-3520" />
      <main data-id="element-3521">
        <ConsularAffairs data-id="element-3522" />
      </main>
      <Footer data-id="element-3523" />
    </div>;
}